/** eslint disabled */
// import  "@wmfe/mach-pro-h5-native-module"
import './machproH5Base/base-h5-safearea';
// import WMNetwork from '@wmfe/mach-pro-h5-native-module/dist/components/WMNetWork';
import { loadRemoteModule } from '@m2h/common/utils/machUtils';
import Raptor from '@m2h/common/raptor';
import request from '../request';
import loganLog from '../logan';
import BaseMach, { NativeModuleMap } from './machproH5Base/base-h5';
// 引入native替代模块
import './machproNative';
import {
  SLCommon, Router, Storage, SLLocation, Statistics, ActivityIndicator, Login, Intl,
  SLABStrategy, Keyboard, EventCenter, SLMapModule, SLCompass, SLUserAddress,
  SLHomeCore, SLCHorn,
} from './modules';

import * as machModules from './modules';
import { pageInitConfig, Toast, Dialog } from './base';

// WMNetwork.requestWx = WMNetwork.request;

// 不使用mach原生H5模块，mpro2h5单独覆盖
const M2H5_CUSTOM_MODULES = ['Network'];
// ----- mpweb适配origin -----
// const M2H5_USETOP_MODULES = ['SLUserAddress'];
// ----- mpweb适配change -----
// SLLocation 加入 top 复用：同源 iframe 的 Mach.requireModule('SLLocation') 返回 top 实例，
// 命中同一份 single-flight 初始化 Promise 与权限快照，iframe 不产生第二次权限探测。
const M2H5_USETOP_MODULES = ['SLUserAddress', 'SLLocation'];
// ----- mpweb适配       -----

const parentMach = parent ? parent.window.Mach : {};

// Mach页面路由级别隔离，每次路由切换也要重新初始化
// https://km.sankuai.com/collabpage/2652780699
const Mach = {
  ...parentMach,
  ...(window.Mach || {}),
  ...BaseMach,
  pageInitConfig,
  requireBundleAsync: (moduleId, options?) => loadRemoteModule('subPackages', moduleId),
  requireModule: (module) => {
    // 站内内嵌的本站页面，使用父容器方法
    // console.log(window.self !== window.top, window !== window.top)
    if (window.self !== window.top && window.top.Mach?.requireModule && M2H5_USETOP_MODULES.includes(module)) {
      return window.top.Mach.requireModule(module);
    }
    // 返回machpro已定义的module
    if (!M2H5_CUSTOM_MODULES.includes(module) && NativeModuleMap.get(module)) {
      return NativeModuleMap.get(module);
    }

    if (machModules[module]) {
      // console.log('machModules', module);
      return machModules[module];
    }

    switch (module) {
      case 'SLRaptor':
      case 'Raptor':
        return Raptor;
      case 'KNB':
        return window.KNB;
      case 'Intl':
        return Intl;
      case 'Dialog':
        return Dialog;
      case 'SLHomeCore':
        return SLHomeCore;
      case 'SLMPCache':
        return {
          getCacheSize(cb) {
            cb
              && cb({
                cacheSize: '0',
              });
          },
        };
      case 'SLCompass':
        return SLCompass;
      case 'SLMapModule':
        return SLMapModule;
      case 'SLLiveAcitvity':
        return {
          endActivity() {},
        };
      case 'SLUserAddress':
        return SLUserAddress;
      case 'SLLocation':
        return SLLocation;
      case 'SLCommon':
        return SLCommon;
      case 'Keyboard':
        return Keyboard;
      case 'SLABStrategy':
        return SLABStrategy;
      case 'EventCenter':
        return EventCenter;
      case 'Statistics':
        return Statistics;
      case 'Logan':
        return {
          log: loganLog,
        };
      case 'Network':
        return {
          requestWx(params, cb) {
            // TODO requestWx 特殊处理
            return request(params).then((data) => {
              cb(data);
            });
          },
          request(params, cb) {
            return request(params).then((data) => {
              cb(data);
            });
          },
        };
      case 'Login':
        return Login;
      case 'SLADJust':
        return {
          trackEvent(token: string) {
            console.log(token);
          },
          trackRevenueEvent(token, currency, revenue) {
            console.log(token, currency, revenue);
          },
        };
      case 'SLCHorn':
        return SLCHorn;
      case 'BackPressModule':
        return {
          addBackPressListener(cb?) {
            return true;
          },
          removeBackPressListener(cb) {},
        };
      case 'IOSBackPressModule':
        return {
          addBackPressListener(cb?) {
            return true;
          },
          removeBackPressListener(id?) {
            return true;
          },
        };
      case 'SLException':
        return {
          reportCodeTryException(params?) {},
        };
      case 'ActivityIndicator':
        return ActivityIndicator;
      case 'Toast':
        return Toast;
      case 'Router':
        return Router;
      case 'Storage':
        return Storage;
      default:
        return {};
    }
  },
};

// Mach.registerModule('Network', WMNetwork);

export default Mach;
